import {
    DateField,
    RecordContextProvider,
    Show,
    TextField,
    useRecordContext
} from "react-admin"
import { DataGrid as MDataGrid } from "@mui/x-data-grid"

import { Paper, Grid, Link as MLink, Typography } from "@mui/material"
import ViewAside from "./ViewPartial/ViewAside"

const ViewPage = () => {
    const record = useRecordContext()

    if (!record) return null

    const { childCategories } = record

    return (
        <Paper elevation={20}>
            <Typography variant="h6" sx={{ m: 2 }}>
                Alt Çalışma Kategorileri
            </Typography>
            <MDataGrid
                getRowId={(row: any) => row.id}
                rows={childCategories || []}
                columns={[
                    {
                        field: "name",
                        headerName: "İsim",
                        sortable: false,
                        flex: 1.4,
                        renderCell: (data) => {
                            return (
                                <RecordContextProvider value={data.row}>
                                    <TextField source="name" variant="subtitle2" />
                                </RecordContextProvider>
                            )
                        }
                    },
                    {
                        field: "slug",
                        headerName: "Slug",
                        sortable: false,
                        flex: 1.4,
                        renderCell: (data) => {
                            return (
                                <RecordContextProvider value={data.row}>
                                    <TextField source="slug" />
                                </RecordContextProvider>
                            )
                        }
                    },
                    {
                        field: "createDate",
                        headerName: "Oluşturulma Tarihi",
                        sortable: false,
                        flex: 1,
                        renderCell: (data) => {
                            return (
                                <RecordContextProvider value={data.row}>
                                    <DateField source="createDate" />
                                </RecordContextProvider>
                            )
                        }
                    }
                ]}
            />
        </Paper>
    )
}

export const FeatureCategoryView = () => (
    <Show title={"Çalışma Alanı Detayı"} actions={false}>
        <Grid container spacing={2} sx={{ mt: 1, px: 2 }}>
            <Grid item xs={3}>
                <ViewAside />
            </Grid>
            <Grid item xs={9}>
                <ViewPage />
            </Grid>
        </Grid>
    </Show>
)
